import logo2 from "../assets/rend2.webp";

const ContactUs = () => {
    return (
        <section className="contactUs" id="contact">
            <div className="contactUsInfo">
                <h1 className='fadeOnScroll' data-translate="contactTitle">Have a game or app idea you'd like to bring to life?</h1>
                <p className='fadeOnScroll' data-translate="contactText">We turn your ideas into fully working interactive experiences - whether it's for education,
                    training,
                    events, or promotion. Just share your concept, goal, or even a rough sketch, and we'll help
                    design,
                    build, and polish a custom game or app that fits your audience perfectly. No need for technical
                    knowledge - we handle the entire process from start to finish.
                </p>
                <br />
                <a href="mailto:contact@igralis.com" className="contactUsButton fadeOnScroll">
                    <i style={{ fontSize: "20px" }} className="fas fa-envelope" /> <b data-translate="contactUsButton">CONTACT US!</b>
                </a>
                <br />
                <a  className='fadeOnScroll' style={{ fontSize: "24px", color: "#141033" }} href="mailto:contact@igralis.com">contact@igralis.com</a>

            </div>
            <div className="contactUsImg">
                <img  className='fadeOnScroll' src={logo2} alt="img" />
            </div>
        </section>
    )
}

export default ContactUs